/** 工商同步冷却时长：5 天 */
export const ENTITY_SYNC_COOLDOWN_MS = 5 * 24 * 60 * 60 * 1000;

/** 企业分类 Tag 配色（categoryNew dict_code 后缀匹配） */
export const CATEGORY_TAG_COLOR: Record<string, string> = {
  company: "#3b82f6",
  individual: "#f97316",
};

/** 判断经营状态是否为异常态（吊销/注销/异常等） */
export const isAbnormalBusinessStatus = (statusCode: string): boolean => {
  const normalized = statusCode.toLowerCase();
  return (
    normalized.includes("revok") ||
    normalized.includes("cancel") ||
    normalized.includes("logout") ||
    normalized.includes("abnormal") ||
    normalized.includes("exception")
  );
};
